import api from '@shared/services/api';

export const editingDataEmployeeService = {
    getPensionableServiceInitial: async (personId) => {
        try {
            const { data } = await api.get(`/pr-pensionable-service-initial/${personId}`);
            return data;
        } catch {
            return null;
        }
    },
    getPersonForPensionable: async (personId) => {
        try {
            const { data } = await api.get(`/persons/for-pensionable/${personId}`);
            return data;
        } catch {
            return null;
        }
    },
    savePensionableServiceInitial: async (body) => {
        const { data } = await api.post('/pr-pensionable-service-initial', body);
        return data;
    },
    updatePensionableServiceInitial: async (id, body) => {
        const { data } = await api.put(`/pr-pensionable-service-initial/${id}`, body);
        return data;
    },
};
